import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  toolbar: {
    height: 70,
  },
  barTitle: {
    width: '100%',
  },
  title: {
    margin: 0,
    padding: 0,
    lineHeight: 1.2,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
    width: '80%',
    maxWidth: 600,
    margin: '0 auto',
  },

  buttonContainer: {
    paddingTop: theme.spacing(2),
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    color: theme.colors.white,
    marginRight: theme.spacing(1),
    backgroundColor: theme.colors.darkBlue,
  },
}));

export default useStyles;
